import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
      <a
  href="mailto:adnankhan3937@gmail.com?subject=Interested in Your Services&body=Hello,%0D%0A%0D%0AI came across your work and I'm impressed with your skills and expertise.%0D%0A%0D%0AI'm interested in discussing a potential collaboration or hiring you for a project.%0D%0A%0D%0ALet's connect and explore how we can work together to achieve our goals.%0D%0A%0D%0AThank you and looking forward to hearing from you!%0D%0A%0D%0ABest regards,%0D%0A[Your Name]"
  target="_blank"
  rel="noopener noreferrer"
>
adnankhan3937@gmail.com
</a>

        <div className="f-icons">
          <Insta color="white" size={"3rem"} onClick={() => window.open('https://instagram.com/adnan_khan3569?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D', '_blank')}/>
          <Facebook color="white" size={"3rem"} onClick={() => window.open('https://www.facebook.com/profile.php?id=100079652867617&mibextid=ZbWKwL', '_blank')}/>
          <Gitub color="white" size={"3rem"} onClick={() => window.open('https://github.com/adnansudozai', '_blank')}/>
        </div>
      </div>
    </div>
  );
};

export default Footer;
